import { render, staticRenderFns } from "./BuildingUsed.vue?vue&type=template&id=562d1740&scoped=true"
import script from "./BuildingUsed.vue?vue&type=script&lang=js"
export * from "./BuildingUsed.vue?vue&type=script&lang=js"
import style0 from "./BuildingUsed.vue?vue&type=style&index=0&id=562d1740&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "562d1740",
  null
  
)

export default component.exports